import { roundUpTo } from 'functions/roundUpTo';
import * as OrderGuide from 'types/Recipe/Detail/ErpNew/OrderGuide';

export type Type = {
	productId: string;
	sourceId: string;
	name: string;
	imageUrl: string;
	price: number | null;
	gtin: string;
	ingredientId?: string;
	priority?: number;
	selected?: boolean;
	externalUrl?: string;
	nutrients: { [nutrientId: string]: number | null };
	size?: number;
};

export function create(): Type {
	return {
		productId: '',
		sourceId: '',
		name: '',
		imageUrl: '',
		price: null,
		gtin: '',
		nutrients: {},
		size: 0,
	};
}

export function toggleSelection(obj: Type): Type {
	return { ...obj, selected: !obj.selected };
}

export function select(obj: Type): Type {
	return { ...obj, selected: true };
}

export function getNutrientValueString(obj: Type, nutrientId: string): string {
	const nutrient: number | null | undefined = obj.nutrients[nutrientId];
	if (!nutrient) return '–';
	return roundUpTo(nutrient, 2);
}

export function applyOrderGuidePriority(obj: Type, orderGuide: OrderGuide.Type): Type {
	if (!obj.ingredientId) return obj;
	const direction = orderGuide[obj.ingredientId]?.find((e) => e.productId === obj.productId);
	if (!direction) return obj;
	return { ...obj, priority: direction.priority ?? 0 };
}

export function getSize(volume: number | null, weight: number | null): number {
	return (volume && volume !== 0 ? volume : weight) || 100;
}
